import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import './SelectAnalyzersTable.scss';
import ArrSingleSelectDropdown from '../../../../../common/arr-select-dropdown/ArrSingleSelectDropdown';
import {
  analyzerDropDownOptions,
  AnalyzerTableData,
} from './selectAnalyzerTableMock';
import {ISelectItem} from '../../../../../../shared/types';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../../../../redux/store';
import {useTranslation} from 'react-i18next';
import classNames from 'classnames';
import {
  setFields,
  IRequestField,
} from '../../../../../../redux/slice/createCustomIndexSlice';
import {METADATA_FIELD_OPTIONS} from '../../metadata-fields/metadataFieldOptions';

const SelectAnalyzersTable = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const {isReadOnlyView, createCustomIndex} = useSelector(
    (state: RootState) => state.indexManagement
  );
  const storedFields: IRequestField[] = createCustomIndex.Fields ?? [];
  const analyzerTablerows: AnalyzerTableData[] = storedFields.map((field) => {
    const matchedField = METADATA_FIELD_OPTIONS.find(
      (option) => Number(option.id) === Number(field.FieldId)
    );
    const matchedAnalyzer = analyzerDropDownOptions.find(
      (option) => Number(option.id) === Number(field.AnalyzerId)
    );
    return {
      id: String(field.FieldId),
      fieldName: String(matchedField?.label ?? `Field ${field.FieldId}`),
      analyzerName: String(matchedAnalyzer?.name ?? ''),
    };
  });

  const handleChange = (value: ISelectItem | null, row: AnalyzerTableData) => {
    const updatedFields = storedFields.map((field) =>
      Number(field.FieldId) === Number(row.id)
        ? {
            ...field,
            AnalyzerId: value?.id ? Number(value.id) : field.AnalyzerId,
          }
        : field
    );
    dispatch(setFields(updatedFields));
  };

  return (
    <Box
      className={classNames(
        'select-analyzers-table',
        isReadOnlyView && 'select-analyzers-readonly-table'
      )}
    >
      <Table aria-label="analyzer-selection-table">
        <TableHead>
          <TableRow>
            <TableCell
              tabIndex={0}
              className="select-analyzer-field-column typo-text label2_size"
            >
              {t('indexManagement.customIndex.selectAnalyzer.selectedFields')}
            </TableCell>
            <TableCell
              tabIndex={0}
              className="select-analyzer-column typo-text label2_size"
            >
              {t('indexManagement.customIndex.selectAnalyzer.analyzerName')}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {analyzerTablerows?.map((row) => (
            <TableRow key={row.id}>
              <TableCell
                tabIndex={0}
                className={classNames(
                  'select-analyzer-field-column',
                  isReadOnlyView && 'select-analyzer-readonly',
                  'table-row typo-text body3_size'
                )}
              >
                {row.fieldName}
              </TableCell>
              <TableCell
                tabIndex={isReadOnlyView ? 0 : -1}
                className={classNames(
                  'select-analyzer-column',
                  'table-row typo-text body3_size',
                  isReadOnlyView && 'select-analyzer-readonly'
                )}
              >
                {isReadOnlyView ? (
                  row.analyzerName
                ) : (
                  <ArrSingleSelectDropdown
                    key={row.id}
                    dropdownItems={analyzerDropDownOptions}
                    dropdownLabel="Select Analyzer"
                    selectedValues={{
                      id: analyzerDropDownOptions.find(
                        (analyzer) => row.analyzerName === analyzer.name
                      )?.id,
                      name: row.analyzerName,
                    }}
                    onSelectionChange={(value) => handleChange(value, row)}
                    sizeVariant="small"
                    dataTestId={`asd-selection-analyzer-table-dropdown-${row.id}`}
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default SelectAnalyzersTable;
